// Frontend runtime guards (production only):
// 1) Silence noisy console output except errors.
// 2) Default scroll-blocking events to passive listeners.

if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_KEEP_CONSOLE !== 'true') {
  const noop = () => {};
  // Keep console.error for real failures, mute noisy levels.
  // eslint-disable-next-line no-console
  console.log = noop;
  // eslint-disable-next-line no-console
  console.info = noop;
  // eslint-disable-next-line no-console
  console.warn = noop;
  // eslint-disable-next-line no-console
  console.debug = noop;
}

if (process.env.NODE_ENV === 'production') {
  const passiveEvents = new Set(['touchstart', 'touchmove', 'wheel', 'mousewheel']);
  const originalAddEventListener = EventTarget.prototype.addEventListener;

  EventTarget.prototype.addEventListener = function patchedAddEventListener(
    type: string,
    listener: EventListenerOrEventListenerObject | null,
    options?: boolean | AddEventListenerOptions
  ) {
    if (!passiveEvents.has(type)) {
      return originalAddEventListener.call(this, type, listener, options as any);
    }

    if (options === undefined) {
      return originalAddEventListener.call(this, type, listener, { passive: true });
    }

    if (options === false) {
      return originalAddEventListener.call(this, type, listener, { passive: true, capture: false });
    }

    if (typeof options === 'object' && options !== null && options.passive === undefined) {
      return originalAddEventListener.call(this, type, listener, { ...options, passive: true });
    }

    return originalAddEventListener.call(this, type, listener, options as any);
  };
}

